var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-fade-transition",
        [
          _vm.targetIndex >= 0
            ? _c(
                "v-sheet",
                {
                  staticClass: "d-flex pa-2",
                  style: {
                    position: "fixed",
                    width: _vm.$vuetify.breakpoint.smAndDown
                      ? "fit-content"
                      : "40%",
                    left: _vm.$vuetify.breakpoint.smAndDown ? "16px" : "30%",
                    bottom: "16px",
                    "z-index": 199,
                    "align-items": "center",
                    "justify-content": _vm.$vuetify.breakpoint.smAndDown
                      ? "flex-start"
                      : "space-between",
                  },
                  attrs: { color: "transparent" },
                },
                [
                  _c(
                    "v-chip",
                    {
                      staticClass: "elevation-8",
                      staticStyle: { "margin-right": "24px" },
                      attrs: {
                        label: "",
                        close: _vm.selectedCounts > 0,
                        color: "primary",
                      },
                      on: { "click:close": _vm.clearAllMotifs },
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.selectionBannerContent),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              top: "",
                              color: _vm.errorFoldseekBtn ? "error" : "primary",
                              value: _vm.errorFoldseekBtn,
                              "open-on-click": false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-3 elevation-8",
                                              attrs: {
                                                color: _vm.errorFoldseekBtn
                                                  ? "error"
                                                  : "primary",
                                                fab: "",
                                                loading: _vm.loading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.sendToFoldseek.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(_vm.$MDI.Monomer)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              9824172
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.toFoldseekContent))]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              top: "",
                              color: _vm.errorFoldDiscoBtn
                                ? "error"
                                : "#eca800",
                              value: _vm.errorFoldDiscoBtn,
                              "open-on-click": false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "elevation-8 fold-disco-btn",
                                              staticStyle: { color: "#fff" },
                                              attrs: {
                                                fab: "",
                                                color: _vm.errorFoldDiscoBtn
                                                  ? "error"
                                                  : "#eca800",
                                                loading: _vm.loading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.sendToFoldDisco.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(_vm.$MDI.Motif)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4104378603
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.toFoldDiscoContent),
                              },
                            }),
                          ]
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", width: "480px" },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { loading: _vm.loading } },
                [
                  _c(
                    "template",
                    { slot: "progress" },
                    [
                      _c("v-progress-linear", {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-title", [_vm._v("Please Wait...!")]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _vm._v(
                      "\n                    We're processing your request. It may take upto a minute...\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: { click: _vm.cancelJob },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }